export const TRACE_ID_HEADER = 'X-Trace-Id';

/** 32-char hex trace ID (matches Java/Python UUID without dashes). */
export function generateTraceId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replaceAll('-', '');
  }
  return Math.random().toString(16).slice(2) + Date.now().toString(16);
}
